import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const OTHER_WELFARE_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./other-welware/other-welware.component').then(m => m.OtherWelwareComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  }
];
